import classNames from 'classnames';

export function ButtonGhost({
  hasOnlyBottomBorder,
  children,
}: {
  hasOnlyBottomBorder?: boolean;
  children: React.ReactNode;
}) {
  const borderClasses = hasOnlyBottomBorder ? 'border-b-2' : 'border-y-2';

  return (
    <div
      className={classNames(
        'flex w-full cursor-pointer items-center justify-center  px-6 py-6 text-center font-extralight uppercase text-brand-500 hover:bg-gray-100',
        borderClasses
      )}
    >
      {children}
    </div>
  );
}
